/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Auth_Shell_Pick_WithInputs */

const en_auth_shell_pick_with = /** @type {(inputs: Auth_Shell_Pick_WithInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`With ${i?.name}. It is waiting for you after sign-in.`)
};

const pl_auth_shell_pick_with = /** @type {(inputs: Auth_Shell_Pick_WithInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`U ${i?.name}. Czeka na Ciebie po zalogowaniu.`)
};

/**
* | output |
* | --- |
* | "With {name}. It is waiting for you after sign-in." |
*
* @param {Auth_Shell_Pick_WithInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_shell_pick_with = /** @type {((inputs: Auth_Shell_Pick_WithInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Shell_Pick_WithInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_shell_pick_with(inputs)
	return en_auth_shell_pick_with(inputs)
});